import Modal from 'antd/lib/modal';
import 'antd/lib/modal/style/css';

export default Modal;
